import { render, staticRenderFns } from "./BasicForm.vue?vue&type=template&id=26e5b943&"
import script from "./BasicForm.vue?vue&type=script&lang=js&"
export * from "./BasicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26e5b943')) {
      api.createRecord('26e5b943', component.options)
    } else {
      api.reload('26e5b943', component.options)
    }
    module.hot.accept("./BasicForm.vue?vue&type=template&id=26e5b943&", function () {
      api.rerender('26e5b943', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examples/form/BasicForm.vue"
export default component.exports